import React from "react";

const Timeline = (props) => {
  return (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21.5C5.20951 21.5 0.5 16.7905 0.5 11C0.5 5.20951 5.20951 0.5 11 0.5C16.7905 0.5 21.5 5.20951 21.5 11C21.5 16.7905 16.7905 21.5 11 21.5ZM11 1.92234C5.99338 1.92234 1.92234 5.99338 1.92234 11C1.92234 16.0066 5.99338 20.0777 11 20.0777C16.0066 20.0777 20.0777 16.0066 20.0777 11C20.0777 5.99338 16.0003 1.92234 11 1.92234Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.5536 15.9625C13.3702 15.9625 13.1869 15.8929 13.0478 15.7538L10.0704 12.7764C9.93767 12.6437 9.86182 12.4603 9.86182 12.2707V6.31586C9.86182 5.92392 10.1779 5.60785 10.5698 5.60785C10.9618 5.60785 11.2778 5.92392 11.2778 6.31586V11.9799L14.0466 14.7487C14.3248 15.0269 14.3248 15.4757 14.0466 15.7538C13.9076 15.8929 13.7242 15.9625 13.5409 15.9625H13.5536Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export { Timeline };
